var card_content_default = {
  "content": "BWxcx",
  "textStart": "uAk8J",
  "contentText": "Sieco",
  "subtitle": "qBfQ8",
  "pricing": "w8Tmu",
  "titlePriceContainer": "SzjTi",
  "textCenter": "EQQ3g",
  "textEnd": "grZ-d",
  "titlePriceSideBySide": "DX2xM",
  "titlePriceStacked": "t0r1M",
  "title": "LIDzj",
  "price": "OZOK7",
  "priceDiscounted": "z69Ap",
  "priceOriginal": "wKkV2",
  "priceStrikethrough": "gIKnt",
  "ribbon": "Ex58q",
  "button": "Q5v3u",
  "button_disabled": "YiVkl",
  "buttonText": "kINgK",
  "framelessContent": "-J-Ih",
  "framelessImageTop": "xXCjh",
  "framelessImageStart": "lpBDm",
  "framelessImageEnd": "DHR-H"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
